var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconComplete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  viewBox: "0 0 64 64"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  transform: "translate(2 2)",
  fill: "none",
  stroke: "#09f",
  strokeWidth: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.674,33.177,27.1,43.116l18.862-20",
  fill: "none",
  stroke: "#09f",
  strokeWidth: 3,
  fillOpacity: 0
})));
export default SvgIconComplete;